export enum MarketingListCustomerStatus {
    Unhandled,
    Unanswered,
    NotInterested
}